


















import { getPatientName, getPatientInitials, sortByPatientName } from '@/utils/patients'

export default {
  props: {
    participants: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    participantsByPatientName() {
      return sortByPatientName(this.participants)
    },
  },
  methods: {
    getFullName(participant) {
      return getPatientName(participant)
    },
    getInitials(participant) {
      return getPatientInitials(participant)
    },
  },
}
